export enum BenefitType {
  STATEMENT_CREDIT = "statement_credit",
  TRAVEL_CREDIT = "travel_credit",
  LOUNGE_ACCESS = "lounge_access",
  TRAVEL_INSURANCE = "travel_insurance",
  PURCHASE_PROTECTION = "purchase_protection",
  EXTENDED_WARRANTY = "extended_warranty",
  RETURN_PROTECTION = "return_protection",
  PRICE_PROTECTION = "price_protection",
  RETURN_SHIPPING = "return_shipping",
  CELL_PHONE_PROTECTION = "cell_phone_protection",
  AUTO_RENTAL_COLLISION_DAMAGE_WAIVER_PRIMARY = "auto_rental_collision_damage_waiver_primary",
  AUTO_RENTAL_COLLISION_DAMAGE_WAIVER_SECONDARY = "auto_rental_collision_damage_waiver_secondary",
  TRIP_CANCELLATION_PROTECTION = "trip_cancellation_protection",
  BAGGAGE_DELAY_INSURANCE = "baggage_delay_insurance",
  LOST_LUGGAGE_REIMBURSEMENT = "lost_luggage_reimbursement",
  TSA_PRE_AND_GLOBAL_ENTRY_CREDIT = "tsa_pre_and_global_entry_credit",
  FREE_CHECKED_BAGS = "free_checked_bags",
  AIRLINE_PRIORITY_BOARDING = "airline_priority_boarding",
  FREE_HOTEL_NIGHT = "free_hotel_night",
  BOGO_FLIGHT_COUPON = "bogo_flight_coupon",
  HOTEL_STATUS = "hotel_status",
  ANNIVERSARY_BONUS = "anniversary_bonus",
  AIRLINE_STATUS = "airline_status",
  AIRLINE_INFLIGHT_PURCHASE_DISCOUNT = "airline_inflight_purchase_discount",
  CREDIT_LIMIT_INCREASE = "credit_limit_increase",
  BANK_OF_AMERICA_PREFERRED_REWARDS = "bank_of_america_preferred_rewards",
  BOFA_SMALL_BUSINESS_ACCOUNT_10_PERCENT_REWARDS_BONUS = "bofa_small_business_account_10_percent_rewards_bonus",
  BOFA_ACCOUNT_10_PERCENT_REWARDS_BONUS = "bofa_account_10_percent_rewards_bonus",
  ROTATING_QUARTERLY_REWARDS = "rotating_quarterly_rewards",
  AIRFARE_DISCOUNT = "airfare_discount",
  AIRLINE_SEAT_UPGRADE = "airline_seat_upgrade",
  AWARD_FLIGHT_DISCOUNT = "award_flight_discount",
  AWARD_PRICING_DISCOUNT = "award_pricing_discount",
  COMPANION_TICKET = "companion_ticket",
  POINTS_TRANSFER = "points_transfer",
  PERSONAL_TRAVEL_CONCIERGE = "personal_travel_concierge",
  INSTACART_PLUS_MEMBERSHIP = "instacart_plus_membership",
  FREE_DOORDASH_DASHPASS = "free_doordash_dashpass",
  AIRLINE_WIFI_CREDIT = "airline_wifi_credit",
  CAR_RENTAL_STATUS = "car_rental_status",
  POINTS_PURCHASE_DISCOUNT = "points_purchase_discount",
  TIER_QUALIFYING_POINTS = "tier_qualifying_points",
  ANNUAL_SPEND_BONUS_POINTS = "bonus_points",
  GAME_PASS_ULTIMATE = "game_pass_ultimate",
}
